import React from 'react';
import { Link } from 'react-router-dom';
import { EncabezadoPagina } from '../components/layout/AppLayout';
import { Campo, EstadoVacio, Panel } from '../components/ui/Basicos';
import { Avatar } from '../components/ui/Etiquetas';
import { PanelGoogleCalendar } from '../components/google/PanelGoogleCalendar';
import { useDatos } from '../contexts/DatosContext';
import { inicialesDe } from '../data/abogados';
import { fechaCorta } from '../utils/fechas';
export function MiCuenta() {
  const {
    abogados,
    usuarioActualId,
    sucursales,
    rol
  } = useDatos();
  const yo = abogados.find(a => a.id === usuarioActualId);
  if (!yo) {
    return <Panel data-id="element-1558" data-mp="3o223whuxmz18">
        <EstadoVacio mensaje="No encontramos tu ficha de personal" data-id="element-1559" data-mp="3o5pyzlg0zti2" />
      </Panel>;
  }
  const sucursal = sucursales.find(s => s.id === yo.sucursalId);
  return <>
      <EncabezadoPagina titulo="Mi cuenta" descripcion="Tus datos en el despacho y las integraciones vinculadas a tu cuenta personal." data-id="element-1560" data-mp="2cq1c0u2ruuh9" />

      <Panel data-id="element-1561" data-mp="nbbhvwapwjwx">
        <div className="flex flex-col gap-5 px-5 py-5 lg:flex-row" data-id="element-1562" data-mp="nbl4rb0guaye">
          <Avatar iniciales={inicialesDe(yo.nombre)} foto={yo.foto} tamano="lg" nombre={yo.nombre} data-id="element-1563" data-mp="saxwoa67287u" />
          <dl className="grid flex-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1564" data-mp="ean5f60z2rm5">
            <Campo etiqueta="Nombre" valor={yo.nombre} data-id="element-1565" data-mp="j8wvj27ub20w" />
            <Campo etiqueta="Rol activo en el sistema" valor={rol} data-id="element-1566" data-mp="4lllx5v7xs3f" />
            <Campo etiqueta="Cédula profesional" valor={yo.cedula} mono data-id="element-1567" data-mp="4j8xc9uygjhe" />
            <Campo etiqueta="Sucursal" valor={sucursal?.nombre ?? '—'} data-id="element-1568" data-mp="9ctujzoq59fj" />
            <Campo etiqueta="Correo del despacho" valor={yo.correo} data-id="element-1569" data-mp="3rqugq17w9gja" />
            <Campo etiqueta="Teléfono" valor={yo.telefono || '—'} data-id="element-1570" data-mp="3vrmrx00btvi7" />
            <Campo etiqueta="Fecha de ingreso" valor={fechaCorta(yo.fechaIngreso)} data-id="element-1571" data-mp="3vrwj2qx3y8ph" />
            <Campo etiqueta="Perfil completo" valor={<Link to={`/abogados/${yo.id}`} className="text-sm font-semibold text-marino-600 hover:text-marino-800" data-id="element-1573" data-mp="3mpx0vvacwyky">
                  Ver carga de trabajo
                </Link>} data-id="element-1572" data-mp="3ht6njfpxsh38" />
          </dl>
        </div>
      </Panel>

      <div className="mt-4" data-id="element-1574" data-mp="1jj7rhhmdbyji">
        <PanelGoogleCalendar abogado={yo} puedeEditar data-id="element-1575" data-mp="1jgbsrr2p55u0" />
      </div>
    </>;
}